module.exports = __webpack_public_path__ + "media/images/pages/home_featured/who-we-are-mid-3-bbbf1edcb5b589cf9453a5a5cf74d24f.png";